import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import { useDebounceEffect } from "components/PictureCropper/useDebounceEffect";
import { useFormContext } from "react-hook-form";
import { isNumber } from "lodash";

function InputSetting({ setting, setParentState, styles = {}, name, validations = {} }) {
  const settingFieldValue = setting.field_value;

  const [localState, setLocalState] = useState(settingFieldValue);
  const {
    register,
    formState: { errors },
    setValue,
    trigger,
  } = useFormContext();

  if (validations?.type === "number" && !validations?.validate)
    validations.validate = (value) =>
      (Number(value) && isNumber(Number(value))) || "Please enter a valid number";

  useDebounceEffect(
    () => {
      if (localState !== setting.field_value) {
        setParentState(localState);
        if (name) {
          setValue(name, localState);
          trigger(name);
        }
      }
    },
    1000,
    [localState]
  );

  useEffect(() => {
    setLocalState(settingFieldValue);
  }, [settingFieldValue]);

  return (
    <Box
      component="form"
      sx={{
        width: "100%",
        marginBottom: "2rem",
        ...styles,
      }}
      noValidate
      autoComplete="off"
    >
      <TextField
        variant="outlined"
        {...(name ? register(name, validations) : {})}
        value={localState}
        label={setting.en_field_label}
        onChange={(e) => setLocalState(e.target.value)}
        sx={{
          width: "100%",
          "& input": {
            padding: "16px",
          },
        }}
        error={errors[name]?.message || false}
        helperText={errors[name]?.message}
      />
    </Box>
  );
}

export default InputSetting;
